export default function Modal({ title, onClose, children, width = 520 }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: width }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
          <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: 16, color: '#e8edf2' }}>
            {title}
          </div>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', color: '#607080',
            fontSize: 20, cursor: 'pointer', lineHeight: 1, padding: '0 4px',
          }}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}
